<div class="SignIn uk-flex-top uk-modal" #modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
        <div class="uk-modal-close-default">
			<span class="IconItem IconItem--close">
				<img src="/assets/img/icon/close.svg" uk-svg>
			</span>
		</div>
        <h2 class="uk-text-center">Чтобы войти в учетную запись, введите свои данные</h2>
		<div class="uk-alert-danger" uk-alert *ngIf='error'><p [innerHtml]="errorMessage"></p></div>
		<div class="uk-alert-success" uk-alert *ngIf='resultMessage && !error'><p [innerHtml]="resultMessage"></p></div>
        <form class="SignIn_Form" action="#" method="post" #signinForm="ngForm" (ngSubmit)="submit($event, signinForm)">
            <div class="uk-margin">
				<input class="uk-input"
					type="email"
					[(ngModel)]="login"
					name="login"
					placeholder="Email"
					email
					required
				>
			</div>
            <div class="uk-margin">
				<input class="uk-input"
					type="password"
					name="password"
					[(ngModel)]="password"
					placeholder="Пароль"
					required
				>
			</div>
            <div class="uk-display-inline-block">
				<a [routerLink]="['', {outlets: {modal: ['signup']}}]" rel="nofollow">Нет аккаунта? Зарегистрируйтесь!</a>
			</div>
			<button class="uk-button uk-button-primary uk-float-right"
				type="submit"
				[disabled]="loadingState || signinForm.form.invalid"
				[ngClass]="loadingState ? 'uk-button-loading' : ''"
			>Войти</button>
		</form>
    </div>
</div>
